
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { addToCart, clearCart, decreaseFromCart, removeFromCart } from '../redux/state/cart/CartSlice';
import api from '../services/api';
import AsyncSelect from "react-select/async";
import { useState } from 'react';
import Swal from 'sweetalert2';


const Checkout = () => {

  const dispatch = useDispatch();
  const cart = useSelector(state => state.cart);

  const convertBnToEn = (value) => {
    return value.replace(/[০-৯]/g, (digit) =>
      String(digit.charCodeAt(0) - 0x09e6)
    );
  };

  // -----------------------------
  // Form States
  // -----------------------------
  const [customerName, setCustomerName] = useState("");
  const [customerMobile, setCustomerMobile] = useState("");
  const [customerEmail, setCustomerEmail] = useState("");
  const [customerDistrictId, setCustomerDistrictId] = useState(null);
  const [customerAddress, setCustomerAddress] = useState("");

  // -----------------------------
  // Load District Options
  // -----------------------------
  const loadDistrictOptions = async (inputValue) => {
    const response = await api.get(`fetch-districts-select2?search=${inputValue}`);
    return response.data.map((item) => ({
      value: item.id,
      label: item.text,
    }));
  };

  // -----------------------------
  // Form Submit Handler
  // -----------------------------
  const handleOrderSubmit = async () => {

  
   const errMessages =
    !customerName ? "Name is required." :
    !customerMobile ? "Mobile number is required." :
    !customerDistrictId ? "District is required." :
    !customerAddress ? "Address is required." :
    "";
    if (errMessages) {
      Swal.fire({
        title: 'Error', 
        text: errMessages,
        icon: 'error'
      });
      return;
    }
    
    const payload = {
      customer_name: customerName,
      customer_mobile: customerMobile,
      customer_email: customerEmail,
      customer_district_id: customerDistrictId.value,
      customer_address: customerAddress,

      cart_items: cart.cartItems,
      subtotal: cart.cartSubTotalAmount,
      delivery_charge: cart.cartDeliveryCharge,
      total: cart.cartSubTotalAmount + cart.cartDeliveryCharge,
    };

    try {
      const res = await api.post("store-order-place", payload);
      if (res.status === 201) {
          Swal.fire({
            title: 'Order Placed Successfully!',
            text: `Your order ID is ${res.data.order_id}. Our team will contact you soon.`,
            icon: 'success',
            confirmButtonText: 'OK'
          });
          dispatch(clearCart());
      } 
    } catch (err) {
       console.log(err);
       Swal.fire({
            title: 'Error',
            text: err.response?.data?.message || 'Something went wrong.',
            icon: 'error'
        });
    }
  };

  const total = (cart.cartSubTotalAmount + cart.cartDeliveryCharge).toLocaleString("en-US");

  return (
    <div className="container my-5">
      <h3 className="text-center mb-4">Checkout</h3>
      {cart.cartItems.length === 0 ? (
            <div className="text-center py-5">
             🛒
              <p className="mt-2 text-secondary">No items found in cart to checkout</p>
              <NavLink
                to="/"
                className="btn btn-dark rounded-pill px-4 py-2 shadow-sm text-decoration-none"
              >
                Return to Home
              </NavLink>
            </div>
          ) : (
          <div className="row g-4">
            {/* Billing Details */}
            <div className="col-md-6">
              <div className="card p-4 shadow-sm border-0" data-no-translate>
                <h5 className="mb-3">Billing details</h5>

                <div className="mb-3">
                  <label className="form-label">আপনার নাম লিখুন <span className='text-danger'>*</span></label>
                  <input type="text" value={customerName} onChange={(e) => setCustomerName(e.target.value)} className="form-control" placeholder="সম্পূর্ণ নাম লিখুন" />
                </div>

              <div className="mb-3">
                <label className="form-label">
                  আপনার মোবাইল নাম্বার লিখুন <span className='text-danger'>*</span>
                </label>

                <input
                  type="text"
                  value={customerMobile}
                  onChange={(e) => {
                    let inputValue = e.target.value;

                    // বাংলা → ইংরেজি ডিজিট কনভার্ট (dynamic)
                    inputValue = convertBnToEn(inputValue);

                    // শুধু ইংরেজি/ডিজিট রাখুন
                    inputValue = inputValue.replace(/\D/g, "");

                    setCustomerMobile(inputValue);
                  }}
                  className="form-control"
                  minLength={11}
                  maxLength={11}
                  placeholder="১১ ডিজিটের মোবাইল নাম্বার লিখুন"
                />
              </div>

                <div className="mb-3">
                  <label className="form-label">ইমেইল</label>
                  <input type="email" value={customerEmail} onChange={(e) => setCustomerEmail(e.target.value)} className="form-control" placeholder="আপনার ইমেইল লিখুন" />
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    জেলা সিলেক্ট করুন <span className="text-danger">*</span>
                  </label>

                  <AsyncSelect
                    cacheOptions
                    defaultOptions
                    loadOptions={loadDistrictOptions}
                    placeholder="-- জেলা নির্বাচন করুন --"
                    isSearchable
                    isClearable={true}
                    value={customerDistrictId}
                    onChange={setCustomerDistrictId}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">সম্পূর্ণ ঠিকানা <span className='text-danger'>*</span></label>
                  <textarea className="form-control" rows="3" placeholder="গ্রাম/মহল্লা, রোড নাম্বার, বাড়ি নাম/নাম্বার, ফ্ল্যাট নাম্বার, উপজেলা, জেলা/শহর" value={customerAddress} onChange={(e) => setCustomerAddress(e.target.value)}></textarea>
                </div>
              </div>
            </div>

            {/* Product Details */}
            <div className="col-md-6">
              <div className="card p-4 shadow-sm border-0">
                <h5 className="mb-3">Product Details</h5>

                {/* Product Item */}
                {cart.cartItems.map((item, index) => 
                  <div key={index} className="d-flex align-items-center justify-content-between mb-3 border-bottom pb-2">
                      <div className="d-flex align-items-center">
                        <img src={process.env.REACT_APP_IMAGEBASE_URL + 'products/' + item.image} alt={item.image} className="cart-thumb me-3"/>
                        <div>
                          <h6 className="mb-0">{item.product_name}</h6>
                          <small>৳ {item.discountedPrice}</small>
                        </div>
                      </div>
                      <div className="d-flex align-items-center border rounded-pill px-3 py-1">
                        <button className="p-0 m-0 border-0 bg-transparent me-3" onClick={() => dispatch(decreaseFromCart(item))}>
                          –
                        </button>
                        <span>{item.cartQuantity}</span>
                        <button className="p-0 m-0 border-0 bg-transparent ms-3" onClick={() => dispatch(addToCart(item))}>
                          +
                        </button>
                      </div>
                      <div className="d-flex flex-column align-items-end">
                        <div className="ms-3 fw-bold">
                          ৳ {item.discountedPrice * item.cartQuantity}
                        </div>

                        <button
                          className="btn-close mt-2"
                          style={{fontSize:'10px'}}
                          onClick={() => dispatch(removeFromCart(item))}
                        ></button>
                      </div>
                  </div>
                )}
                  

                {/* Total & Checkout */}
                <div className="mt-3">
                  <div className="d-flex justify-content-between">
                    <span>Sub Total</span>
                    <span>৳ {cart.cartSubTotalAmount.toLocaleString('en-US')}</span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>Delivery Charge (All Bangladesh)</span>
                    <span>৳ {cart.cartDeliveryCharge}</span>
                  </div>
                  <hr />
                  <div className="d-flex justify-content-between fw-bold fs-5">
                    <span>Total</span>
                    <span>{total} TK</span>
                  </div>

                  <div className="form-check mt-3">
                    <input className="form-check-input" type="radio" id="cod" defaultChecked />
                    <label className="form-check-label" htmlFor="cod">
                      Cash On Delivery
                    </label>
                  </div>

                  <div className="input-group mt-3">
                    <input type="text" className="form-control" placeholder="Enter Promo Code" />
                    <button className="btn btn-secondary">Apply</button>
                  </div>

                  <button
                    className="btn btn-dark w-100 rounded-pill mt-3 py-2"
                    onClick={handleOrderSubmit}
                  >
                    Confirm Order {total} TK
                  </button>
                </div>
              </div>
            </div>
          </div>
      )}
    </div>
  );
};

export default Checkout;
